import React, { ReactNode } from 'react';
import classNames from 'classnames';
import './summary-panel.scss';
import { Container, Label, Value } from './summary-panel-row.styles';

interface SummaryPanelRowProps {
  label?: ReactNode;
  value?: ReactNode;
  isHiddenByDefault?: boolean;
  children?: ReactNode;
  testId?: string;
  useWrapper?: boolean;
  isEllipsisRequired?: boolean;
}

export const SUMMARY_ITEM_HIDDEN_CLASS_NAME = 'summary-item-hidden';

export const SummaryPanelRow = ({
  label,
  value,
  isHiddenByDefault = false,
  children,
  testId,
  useWrapper = false,
  isEllipsisRequired = false,
}: SummaryPanelRowProps) => {
  if (useWrapper) {
    return (
      <Container id="summary-panel-row" className="summary-panel-row" data-testid={testId}>
        <Label data-testid={testId ? `${testId}-label` : undefined}>{label}</Label>
        <Value
          className={classNames({ 'text-ellipsis': isEllipsisRequired })}
          data-testid={testId ? `${testId}-value` : undefined}
        >
          {value}
        </Value>
      </Container>
    );
  }

  return (
    <div className={`summary-item ${isHiddenByDefault ? SUMMARY_ITEM_HIDDEN_CLASS_NAME : ''}`} data-testid={testId}>
      {children ? (
        children
      ) : (
        <>
          <div className="title" data-testid={testId ? `${testId}-label` : undefined}>
            {label}
          </div>
          <div className="description" data-testid={testId ? `${testId}-value` : undefined}>
            {value}
          </div>
        </>
      )}
    </div>
  );
};
